import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import {
  getAnnouncement,
  DeleteAnnouncement,
  getAnnouncementYear,
} from "./Services/AnnouncementService";
import { GetMasterSystemAlert } from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import { TostMsg } from "../../../App";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { InputSwitch } from "primereact/inputswitch";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader")),
);
const defaultImage = "/images/no-data-found/announcement01.jpg";
const defaultProfileImage = "/images/placeholder_profile.png";

function Announcement() {
  const [announcementData, setAnnouncementList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState("All Years");
  const Category = ["All", "Latest"];
  const [selectedCategory, setselectedCategory] = useState(Category[0]);
  const [announcementDeleteId, setAnnouncementDeleteId] = useState(0);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [page, setPage] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [feature, setFeature] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [noData, setNoData] = useState([]);

  const [previousParams, setPreviousParams] = useState({
    year: "All Years",
    category: "All",
    isFuture: false,
  });
  const observer = useRef();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [announcementYearList, setAnnouncementYearList] = useState();
  const [showAwardDataNotFound, setShowAwardDataNotFound] = useState(false);
  let history = useHistory();

  useEffect(() => {
    GetMasterSystemAlertList("Announcements_header_desc", 1);
    GetMasterSystemAlertList("No_Announcement", 2);
    getAnnouncementYearData();
    permissionAccouncementList();
    GetAnnouncementList(selectedYear, selectedCategory, isChecked, page);
    // setTimeout(() => {
    //   GetAnnouncementList(selectedYear, selectedCategory, isChecked, page);
    // }, 1000);
  }, []);

  useEffect(() => {
    if (page > 1) {
      GetAnnouncementList(
        selectedYear,
        selectedCategory,
        isChecked,
        page,
        true,
      );
    }
  }, [page, isChecked, selectedYear, selectedCategory]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Announcement.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Announcement.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Announcement.Delete") {
        setDeleted(true);
      } else if (UserPermission.PermissionName == "Announcement.Upcoming") {
        setFeature(true);
      }
    });
  };

  async function GetAnnouncementList(
    selectedYear,
    selectedCategory,
    isChecked,
    page,
  ) {
    setLoading(true);
    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      year: selectedYear === "All Years" ? "" : String(selectedYear),
      AnnouncementType: selectedCategory === "Latest" ? 1 : 0,
      FutureAnnouncement: isChecked ? 1 : 0,
      GUID: "",
      PageNumber: page,
      PageSize: 10,
    };

    try {
      const response = await getAnnouncement(params);
      let apiData = response?.Data || [];
      const filteredData = isChecked
        ? apiData.filter((item) => item.IsFutureAnnouncement === true)
        : apiData;
      const isFilterChanged =
        previousParams.year !== selectedYear ||
        previousParams.category !== selectedCategory ||
        previousParams.isFuture !== isChecked;
      if (page === 1 || isFilterChanged) {
        setAnnouncementList(filteredData);
      } else {
        setAnnouncementList((prev) => [...prev, ...filteredData]);
      }
      setHasMore(filteredData.length === 10);
      setPreviousParams({
        year: selectedYear,
        category: selectedCategory,
        isFuture: isChecked,
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function getAnnouncementYearData() {
    // setLoading(true);
    const params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      const response = await getAnnouncementYear(params);
      let yearDetail = response?.Data?.toSpliced(0, 0, {
        Year: "All Years",
      });
      setAnnouncementYearList(yearDetail);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  async function deleteAnnouncementDetails() {
    if (announcementDeleteId) {
      let body = {
        Id: announcementDeleteId,
      };
      setLoading(true);

      try {
        let experiencesLists = await DeleteAnnouncement(body);
        if (experiencesLists) {
          GetMasterSystemAlertList("Announcement_deleted", 0);
          setPage(0);
          GetAnnouncementList(
            selectedYear,
            selectedCategory,
            isChecked,
            1,
            true,
          );
          setLoading(false);
          document.getElementById("delete-ed").click();
        }
      } catch (error) {
        setLoading(false);
      }
    }
  }
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleProfileImageError = useCallback((event) => {
    event.target.src = defaultProfileImage;
  }, []);

  const AnnouncementDetails = (event) => {
    history.push(`/Announcement/Detail/${event?.GUID}`);
  };
  const AnnouncementEdit = (event) => {
    history.push(`/Announcement/Edit/${event?.GUID}`);
  };
  const handleInputChangeYear = (e) => {
    setPage(1);
    setHasMore(false);
    setSelectedYear(e.value);
    GetAnnouncementList(e.value, selectedCategory, isChecked, 1);
  };

  const handleInputChangeCategory = (e) => {
    setPage(1);
    setHasMore(false);
    setselectedCategory(e.value);
    GetAnnouncementList(selectedYear, e.value, isChecked, 1);
  };

  const handleInputChangeFeature = (e) => {
    setIsChecked(e.value);
    setPage(1);
    setHasMore(true);
    GetAnnouncementList(selectedYear, selectedCategory, e.value, 1);
  };

  const lastAwardElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (!hasMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore],
  );

  return (
    <div>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="form-head ">
            <div className="row">
              <div className="col-lg-5">
                <div className="me-auto">
                  <h2 className="font-w600 mb-0">{T("Announcements")}</h2>
                  <p className="text-light">{masterSystemAlertData}</p>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="rightside-tabs">
                  <div className="me-2">
                    <div className="org-cate">
                      <div className="">
                        <Dropdown
                          value={selectedYear}
                          onChange={(e) => handleInputChangeYear(e)}
                          options={announcementYearList}
                          placeholder="Select a year"
                          checkmark={true}
                          highlightOnSelect={false}
                          optionLabel="Year"
                          optionValue="Year"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="me-2">
                    <div className="org-cate">
                      <Dropdown
                        value={selectedCategory}
                        onChange={(e) => handleInputChangeCategory(e)}
                        options={Category}
                        placeholder="All"
                        checkmark={true}
                        highlightOnSelect={false}
                      />{" "}
                    </div>
                  </div>

                  {feature && (
                    <div className="me-2 select-futurepost">
                      <label>
                        {isChecked
                          ? "Future Announcements"
                          : "Future Announcements"}
                      </label>
                      <div className="ml-auto d-flex">
                        <InputSwitch
                          checked={isChecked}
                          onChange={(e) => handleInputChangeFeature(e)}
                        />
                      </div>
                    </div>
                  )}
                  <div className="">
                    {create && (
                      <Link to="/Announcement/New" title="Add">
                        <div className="org-add">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-plus"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                          </svg>
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="row g-3">
              {announcementData?.map((lst, index) => {
                const isLastElement = index === announcementData.length - 1;
                return (
                  <div
                    className="col-xl-3"
                    key={index}
                    ref={isLastElement ? lastAwardElementRef : null}
                  >
                    <div className="card announce-card mb-0">
                      <div className="announcements-list">
                        <div className="action-btns">
                          {update && (
                            <span
                              onClick={() => AnnouncementEdit(lst)}
                              className="btn me-1 edit "
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Edit"
                            >
                              <img
                                src="/images/tickets/edit-ico.svg"
                                className="editdivinfo"
                              />
                            </span>
                          )}
                          {deleted && (
                            <span
                              className="btn delete"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-ed"
                              title=""
                              data-bs-original-title="delete"
                              aria-label="delete"
                              onClick={() => setAnnouncementDeleteId(lst?.Id)}
                            >
                              <img
                                src="/images/tickets/delete.svg"
                                className="editdivinfo"
                              />
                            </span>
                          )}
                        </div>
                        <div
                          className="list-card"
                          onClick={() => AnnouncementDetails(lst)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="font-text-display">
                            <h5 className="card-title"> {lst?.Title} </h5>
                            <strong className="first-strong">
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: lst?.Desc?.slice(0, 150),
                                }}
                              />
                              {lst?.Desc.length >= 150 ? (
                                <div>
                                  ...
                                  <a
                                    data-bs-toggle="modal"
                                    data-bs-target="#more-descss"
                                  >
                                    {" "}
                                    more
                                  </a>{" "}
                                </div>
                              ) : (
                                ""
                              )}
                            </strong>
                          </div>
                          {lst?.Image ? (
                            <div className="icon-bell">
                              <img
                                src={lst.Image || defaultImage}
                                onError={handleImageError}
                                width="32"
                                style={{ opacity: "1" }}
                              />
                            </div>
                          ) : (
                            <div className="icon-bell">
                              <img src={defaultImage} className="" />
                            </div>
                          )}
                          <strong className="announced-by">
                            By :{" "}
                            {lst?.ModifiedProfileImage && (
                              <img
                                src={
                                  lst?.ModifiedProfileImage ||
                                  defaultProfileImage
                                }
                                onError={handleProfileImageError}
                                alt="Announcement Profile"
                              />
                            )}
                            {lst?.ModifiedByName}
                            <p>
                              <img src="/images/policy/date.svg" />
                              {moment(lst?.Date).format("MMM DD YYYY")}
                            </p>
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {!loading && announcementData?.length === 0 && (
                <div className="notfound">
                  <img src="images/no-data-found/no-announcement.png" />
                  <h4>{noData}</h4>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this announcement?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAnnouncementDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default Announcement;
